/*eslint eqeqeq: "off"*/
import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Card,
  TableBody,
  TableCell,
  TableRow,
  makeStyles,
  IconButton,
  Avatar,
} from "@material-ui/core";
import { Edit as EditIcon, Trash2 as DeleteIcon } from "react-feather";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteSingleDetails,
  editSingleDetails,
  getProductStoneDetails,
} from "./_product_Action";
import commanTable from "../../components/commanTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { config } from "../../Constants";
import DeleteDialog from "src/components/DeleteDialog";

let REACT_APP_PATH = config.url.PRODUCT_IMG_PATH;
const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const headCells = [
  { id: "productImage", label: "Product Image", disableSorting: true },
  { id: "productDesignNo", label: "Design No" },
  { id: "categoryName", label: "Category Name" },
  { id: "edit", label: "Edit", disableSorting: true },
  { id: "delete", label: "Delete", disableSorting: true },
];

const ProductList = ({ className, TableData, filterFn, ...rest }) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  } = commanTable(TableData, headCells, filterFn, 1);
  const [dialogopen, setDialogOpen] = React.useState(false);
  const [deleteRecord, setDeleteRecord] = React.useState("");

  const editDetails = (id, data) => {
    dispatch(editSingleDetails(id, data));

    dispatch(getProductStoneDetails(id, navigate));
  };
  const openDialog = (id) => {
    setDeleteRecord(id);
    setDialogOpen(!dialogopen);
  };
  const confirmDialog = () => {
    dispatch(deleteSingleDetails(deleteRecord));
  };

  var serverImagePath = REACT_APP_PATH;

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <ToastContainer />
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <TblContainer>
            <TblHead />
            {TableData.length > 0 ? (
              <TableBody>
                {/* {TableData.slice(0, limit).map((row) => ( */}
                {recordsAfterPagingAndSorting().map((row) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Box alignItems="center" display="flex">
                        <Avatar
                          className={classes.avatar}
                          src={serverImagePath + row.productImage}
                        />
                      </Box>
                    </TableCell>
                    {/* <TableCell>
          {row.productName}
        </TableCell> */}
                    <TableCell>{row.productDesignNo}</TableCell>
                    <TableCell>{row.categoryName}</TableCell>

                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() => editDetails(row.id, row)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() => openDialog(row.id)}
                      >
                        <DeleteIcon />
                        {deleteRecord == row.id ? (
                          <DeleteDialog
                            openDialog={openDialog}
                            confirmDialog={confirmDialog}
                            dialogopen={dialogopen}
                          />
                        ) : (
                          ""
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <caption>No Record Found...</caption>
            )}
          </TblContainer>
        </Box>
      </PerfectScrollbar>
      <TblPagination />
    </Card>
  );
};

ProductList.propTypes = {
  className: PropTypes.string,
};

export default ProductList;
